(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pwtq-gallery-toggle]').forEach((btn) => {
    if (btn.dataset.pwtqInit) return;
    btn.dataset.pwtqInit = 'true';
    btn.addEventListener('click', () => {
      const container = btn.closest('.pwtq-product-gallery');
      const expanded = container.classList.toggle('pwtq-gallery--expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const more = btn.querySelector('[data-pwtq-gallery-label-more]');
      const less = btn.querySelector('[data-pwtq-gallery-label-less]');
      if (more) more.hidden = expanded;
      if (less) less.hidden = !expanded;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
